import { request } from '../../common/helpers/request';

export const updateDevice = async (id: string, body?: object) : Promise<object> => request(`/device/${id}`, 'PATCH', body, true);

export default {
  updateDevice,
};
